import type { DeliveryMethodKind } from "@dransay/api/models";
import {
	ExpressAvailabilityHeaderCard,
	ExpressAvailabilityHeaderCardSkeleton,
} from "~/features/products/express-availability-header-card.component";
import { ExpressAvailabilityHeaderOutsideHoursCard } from "~/features/products/express-availability-header-outside-hours-card.component";
import { useHeaderExpressAvailabilityCard } from "~/hooks/use-header-express-availability-card";

interface ExpressAvailabilityHeaderCardHostProps {
	enabled: boolean;
	postalCode: string | undefined;
	expressVendorIds: readonly string[];
	selectedDeliveryMethodKind: DeliveryMethodKind;
}

export function ExpressAvailabilityHeaderCardHost({
	enabled,
	postalCode,
	expressVendorIds,
	selectedDeliveryMethodKind,
}: Readonly<ExpressAvailabilityHeaderCardHostProps>) {
	const { isVisible, isOutsideHours, isLoading, dismiss } =
		useHeaderExpressAvailabilityCard({
			enabled,
			postalCode,
			expressVendorIds,
			selectedDeliveryMethodKind,
		});

	if (isLoading) {
		return <ExpressAvailabilityHeaderCardSkeleton />;
	}

	if (isVisible) {
		return <ExpressAvailabilityHeaderCard onDismiss={dismiss} />;
	}

	if (isOutsideHours) {
		return <ExpressAvailabilityHeaderOutsideHoursCard />;
	}

	return null;
}
